"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomBar = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const common_1 = require("@/components/common");
require("@/components/common");
const selection_indicator_controller_1 = require("@/controllers/selection-indicator-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
const defaultItems = [
    { label: '홈', href: '#', icon: common_1.ICON_NAMES.HOME, active: true },
    { label: '카테고리', href: '#', icon: common_1.ICON_NAMES.HOME },
    { label: '설정', href: '#', icon: common_1.ICON_NAMES.HOME },
];
let BottomBar = class BottomBar extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.items = defaultItems;
        this.ariaLabel = '하단 내비게이션';
        this.selectedIndex = null;
        this.indicatorPosition = new selection_indicator_controller_1.SelectionIndicatorController(this, {
            getContainer: () => this.bottomBar,
            getIndicator: () => this.indicator,
            getTarget: () => this.currentLink ?? undefined,
        });
    }
    render() {
        const items = this.resolvedItems;
        const activeIndex = this.resolveActiveIndex(items);
        return (0, lit_1.html) `
      <nav aria-label=${this.ariaLabel}>
        <span class="indicator" aria-hidden="true"></span>
        ${this.renderItems(items, activeIndex)}
      </nav>
    `;
    }
    get resolvedItems() {
        if (!this.items.length)
            return defaultItems;
        return this.items;
    }
    resolveActiveIndex(items) {
        if (this.selectedIndex !== null)
            return this.selectedIndex;
        const activeIndex = items.findIndex(item => item.active);
        if (activeIndex < 0)
            return null;
        return activeIndex;
    }
    renderItems(items, activeIndex) {
        return items.map((item, index) => this.renderItem(item, index, activeIndex));
    }
    renderItem(item, index, activeIndex) {
        return (0, lit_1.html) `
      <a
        href=${item.href ?? '#'}
        aria-current=${(0, if_defined_js_1.ifDefined)(activeIndex === index ? 'page' : undefined)}
        @click=${(e) => this.handleItemClick(e, index, item)}
      >
        <mm-avatar variant="tertiary" size="32" icon=${item.icon ?? common_1.ICON_NAMES.HOME}></mm-avatar>
        <mm-caption>${item.label}</mm-caption>
        ${this.renderCurrentIndicator(activeIndex === index)}
      </a>
    `;
    }
    renderCurrentIndicator(isCurrent) {
        if (!isCurrent)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-current-indicator></mm-current-indicator>
    `;
    }
    handleItemClick(e, index, item) {
        if (!item.href || item.href === '#')
            e.preventDefault();
        this.selectedIndex = index;
        (0, utils_1.emit)(this, 'change', { index });
    }
};
BottomBar.styles = [
    shared_styles_1.resetStyles,
    (0, lit_1.css) `
      :host {
        display: block;
      }

      nav {
        display: flex;
        justify-content: space-around;
        margin: var(--space-2);
        border: var(--material-base-border);
        border-radius: var(--radius-large);
        background: var(--material-base-background-color);
        box-shadow: var(--material-base-shadow);
        backdrop-filter: var(--material-base-backdrop-filter);
        -webkit-backdrop-filter: var(--material-base-backdrop-filter);
        position: relative;
      }

      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        min-width: var(--size-48);
        padding-bottom: var(--space-1);
        border-radius: var(--radius);
        color: var(--foreground-color);
        position: relative;
        z-index: var(--material-zindex-elevated);
      }

      a:focus-visible {
        ${shared_styles_1.focusRingStyles};
      }

      a[aria-current='page'] {
        color: var(--interaction-selected-foreground-color);
      }

      a[aria-current='page'] mm-avatar {
        --avatar-icon-color: var(--interaction-selected-foreground-color);
      }

      a[aria-current='page'] mm-caption {
        --foreground-subtle-color: var(--interaction-selected-foreground-color);
      }

      /* 막대 안에는 캡션 아래 자리가 없어, 가운데 놓인 아바타의 오른쪽 위 모서리에 얹는다. */
      mm-current-indicator {
        position: absolute;
        top: var(--space-1);
        left: calc(50% + var(--size-32) / 2);
        translate: -50% -50%;
      }

      .indicator {
        width: 0;
        border-radius: var(--radius-large);
        background: var(--interaction-selected-background-color);
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        transform: translateX(0);
        transition: transform var(--transition-duration) var(--transition-easing);
        pointer-events: none;
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], BottomBar.prototype, "items", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], BottomBar.prototype, "ariaLabel", void 0);
__decorate([
    (0, decorators_js_1.state)()
], BottomBar.prototype, "selectedIndex", void 0);
__decorate([
    (0, decorators_js_1.query)('nav')
], BottomBar.prototype, "bottomBar", void 0);
__decorate([
    (0, decorators_js_1.query)('.indicator')
], BottomBar.prototype, "indicator", void 0);
__decorate([
    (0, decorators_js_1.query)("a[aria-current='page']")
], BottomBar.prototype, "currentLink", void 0);
BottomBar = __decorate([
    (0, decorators_js_1.customElement)('mm-bottom-bar')
], BottomBar);
exports.BottomBar = BottomBar;
//# sourceMappingURL=data:application/json;base64,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